module.exports = __webpack_public_path__ + "img/coctail-1.c0d529a1.png";